import { createRouter, createWebHistory } from "vue-router";
import TableView from "./TableView.vue";
import FixedLayoutTables from "./FixedLayoutTables.vue";
import TimersPage from "./TimersPage.vue";
import ClocksPage from "./ClocksPage.vue";
import RecordsPage from "./RecordsPage.vue";
import LoadSettings from "./LoadSettings.vue";
import ChannelConfiguration from "./ChannelConfiguration.vue";
import ChannelAssignments from "./ChannelAssignments.vue";
import ConfigureStatus from "./ConfigureStatus.vue";
import UpgradePage from "./UpgradePage.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: "/", component: FixedLayoutTables, props: { width: "275px" } },
    { path: "/basicSettings", component: TableView },
    { path: "/modes", component: ClocksPage },
    { path: "/fanSpeedSettings", component: TableView },
    { path: "/refrigSettings", component: TableView },
    { path: "/heatSettings", component: TableView },
    { path: "/co2Settings", component: TableView },
    { path: "/dryingSettings", component: TableView },
    { path: "/humiditySettings", component: TableView },
    { path: "/dewpointSettings", component: TableView },
    { path: "/controlTempSelections", component: TableView },
    { path: "/aggregateAlarms", component: FixedLayoutTables, props: { width: "275px" } },
    { path: "/systemSettings", component: TableView },
    { path: "/saveAndLoadSettings", component: LoadSettings },
    { path: "/records", component: RecordsPage },
    { path: "/channelConfiguration", component: ChannelConfiguration },
    { path: "/channelAssignments", component: ChannelAssignments },
    { path: "/configureStatus", component: ConfigureStatus },
    { path: "/networkSettings", component: TableView },
    { path: "/timers", component: TimersPage },
    { path: "/rates", component: TableView },
    { path: "/upgrade", component: UpgradePage },
    {
      path: "/:pathMatch(.*)*",
      beforeEnter(to) {
        const href = router.resolve(to).href;
        window.location.assign(href);
        return false;
      },
    },
  ]
});

let inactivityTimer = null;
function resetInactivityTimer() {
  if (inactivityTimer) clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    store.showAdvanced = false;
    if (router.currentRoute.value.path != "/") {
      router.push("/")
    }
  }, 60 * 60 * 1000);
}

// Initialize the inactivity timer.
resetInactivityTimer();

// Reset the inactivity timer on user input or navigation.
let inactivityEvents = [ "mousemove", "mousedown", "keydown", "touchstart", "scroll", "wheel" ];
inactivityEvents.forEach(event => window.addEventListener(event, resetInactivityTimer, { passive: true }));
router.afterEach(() => resetInactivityTimer());

export default router;
